import * as _ from 'lodash';

angular.module("tromanWeb").controller('WageGroupOrganizationsController', ['$q', 'stateService', 'tromanServer', 'ObjectCache', 'dialogService', 'wageGroupShared', function ($q, stateService, tromanServer, ObjectCache, dialogService, wageGroupShared) {

    this.selectedOrganization = null;
    const round = wageGroupShared.wageGroup.CurrentRound;
    this.isRoundLocked = !!(round == null || round.PaymentRound.IsLocked);
    this.busy = false;

    this.$onInit = function $onInit() {
        ObjectCache.getOrganizations(null, { Archived: 1 })
            .then(data => {
                const all = _.partition(data, x => x.WageGroupId == wageGroupShared.wageGroup.Id);
                this.includedOrganizations = all[0];
                this.otherOrganizations = all[1].filter(x => x.Active);
            })
            .catch(dialogService.error);
    };

    this._block = function _block(promise) {
        $q(resolve => {
            this.busy = true;
            resolve(promise);
        }).finally(() => this.busy = false);
    };

    this.canAddOrganization = function () {
        return !this.busy && this.selectedOrganization != null;
    };

    this.addOrganization = function () {
        if (!this.canAddOrganization()) return;

        const src = this.selectedOrganization;

        var cp = src.clone();
        cp.WageGroup = wageGroupShared.wageGroup;

        let confirmation = true;
        if (src.WageGroup != null) {
            confirmation = dialogService.confirm([src.Name + ' hör redan till lönegruppen ' + src.WageGroup.Name + ', är du säker?']);
        }

        let promise = $q.resolve(confirmation)
            .then(() => tromanServer.Organizations
                .updateEntity(cp)
                .then(() => stateService.reload())
                .catch(dialogService.error))
            .catch(_.noop);
        this._block(promise);
    };

    this.canRemoveOrganizations = function () {
        return !this.busy && this.table.selectionCount > 0 && this.isRoundLocked;
    };

    this.removeOrganizations = function () {
        if (!this.canRemoveOrganizations()) return;

        var list = this.table.selectedItems();

        var msg =
            'Ta bort lönegruppen från ' +
            list.length +
            (list.length > 1 ? ' valda organisationer.' : ' vald organisation.');

        let promise = dialogService.confirm([msg, 'Är du säker?'])
            .then(() => tromanServer.Organizations.removeWageGroup(list)
                .then(() => stateService.reload())
                .catch(dialogService.error))
            .catch(_.noop);
        this._block(promise);
    };
}]);

